import { CaretRightOutlined } from '@ant-design/icons';
import { Layout, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ContentBox } from '../../../components';
import jobsService from '../../../services/jobs.service';
import { notifyError } from '../../../utils/notification';
import { JobForm } from './job-form';

const { Content } = Layout;
export const EditJobPost: React.FC<any> = props => {
	const [job, setJob] = useState<any>(null);
	const [company, setCompany] = useState<any>(null);
	const [candidates, setCandidates] = useState<any>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [modalVisible, setModalVisible] = useState<boolean>(false);

	const navigate = useNavigate();

	let { jobId } = useParams();
	const mountLogic = async () => {
		let job;
		try {
			job = await jobsService.getJob(jobId);
			if (job === null) throw new Error('Error while fetching data, Please try again later.');
		} catch (e: any) {
			notifyError(e.message);
			setLoading(false);
			return;
		}
		const company = job.company;
		setJob(job);
		setCompany(company);
		setLoading(false);
	};

	useEffect(() => {
		mountLogic();
	}, []);

	const onSubmit = async data => {
		let response;
		try {
			response = await jobsService.editJob(jobId, data);
			if (response === null || !response.succeded)
				throw new Error('Sorry!, something went wrong, Please try again later.');
		} catch (e: any) {
			console.error(e.message);
			notifyError(e.message);
			return;
		}
		setLoading(false);
		navigate(`/dashboard/job/${jobId}`);
	};

	const onHiringProcessRemove = (id, jobDescription) => {
		setJob({
			...job,
			jobDescription,
			hiringProcess: job.hiringProcess.filter(p => p._id !== id)
		});
	};

	return (
		<Content style={{ backgroundColor: '#ffffff', height: '100%' }}>
			<ContentBox marginTop={0} minHeight={150} padding="1.5rem 0">
				{company && (
					<Row className="job-view d-flex align-items-center mb-3 justify-content-center justify-content-lg-start">
						<Link to={`/dashboard/company/${company?._id}`}>{company?.company?.name}</Link>
						<CaretRightOutlined className="mx-1" />
						<Link to={`/dashboard/job/${job?.id}/edit`}>Edit Job</Link>
					</Row>
				)}
				<Row className="job-view d-flex flex-column flex-lg-row align-items-center align-items-lg-stretch justify-content-center justify-content-lg-start">
					<h1>Edit Job</h1>
				</Row>
			</ContentBox>
			<Spin spinning={loading}>
				<JobForm
					onHiringProcessRemove={onHiringProcessRemove}
					{...props}
					job={job}
					onSubmit={onSubmit}
					submitText="Update"
				/>
			</Spin>
		</Content>
	);
};
